import { useTranslation } from 'next-i18next'
import { Icon } from '@captaincause/ui/Icon'
import { tm } from '@captaincause/ui/tm'
import type { Campaign, Project } from '@captaincause/types'

interface CampaignStateBannerProps {
  campaign?: Campaign
  project?: Project
  fixed?: boolean
}

const getBannerMessage = (
  campaign: Campaign | undefined,
  project: Project | undefined,
) => {
  if (campaign?.is_used) {
    return 'used'
  }

  if (campaign?.is_saturated) {
    return 'saturated'
  }

  if (campaign?.is_test) {
    return 'test'
  }

  if (!campaign && project?.status === 'archived') {
    return 'archived'
  }

  return undefined
}

export function CampaignStateBanner({
  project = undefined,
  campaign = undefined,
  fixed = false,
}: CampaignStateBannerProps) {
  const { t } = useTranslation('campaign-banner.component')

  const message = getBannerMessage(campaign, project)
  if (!message) {
    return null
  }

  return (
    <div
      className={tm(
        'top-0 z-40 h-auto w-full border-b bg-white px-6 shadow-md md:h-[56px] md:max-h-[56px]',
        fixed ? 'fixed' : 'relative',
      )}
      style={{ borderColor: campaign?.secondary_color }}
    >
      <div className="flex h-full flex-col items-center justify-center space-x-4 py-3 md:flex-row md:py-4">
        <div className="mb-1 h-10 w-10 min-w-fit md:mb-0 md:block md:h-6 md:w-6">
          <Icon icon="diftyV2" fill="fill-black" />
        </div>
        <span className="text-center text-sm font-semibold">{t(message)}</span>
      </div>
    </div>
  )
}
